/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

export const BUYER_ADMIN_ROLE = '-21';
export const BUYER_APPROVER_ROLE = '-22';
export const ROLES_DETAILS = 'IBM_Assigned_Roles_Details';
